import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import WebinarInscricao from "@/pages/WebinarInscricao";
import ConfiguracaoWebinar from "@/pages/ConfiguracaoWebinar";
import Inscritos from "@/pages/Inscritos";
import Home from "@/pages/Home";

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WebinarInscricao />} />
          <Route path="/WebinarInscricao" element={<WebinarInscricao />} />
          <Route path="/ConfiguracaoWebinar" element={<ConfiguracaoWebinar />} />
          <Route path="/Inscritos" element={<Inscritos />} />
          <Route path="/Home" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
